import { hasInternalPermission } from "@/stores/user";
import type { MiddlewareContext } from "@/types";
import { useUserStore } from "@/stores/user";

export const hasInternalPermissionCanManageOrganizations = ({
  next,
  router
}: MiddlewareContext) => {
  const store = useUserStore();
  if (!hasInternalPermission(store, "can_manage_organizations")) {
    router.push({ name: "PageRestricted" });
    return;
  }
  return next();
};
